import {CopilotIcon} from '@primer/octicons-react'
import {Dialog} from '@primer/react'

import styles from './TriageAgentDialog.module.css'

type TriageAgentDialogProps = {
  onClose: () => void
}

export function TriageAgentDialog({onClose}: TriageAgentDialogProps) {
  return (
    <Dialog title="Triage agent" onClose={onClose}>
      <div className={styles.dialogContent}>
        <CopilotIcon size={48} />
        <span className={styles.comingSoonText}>Coming soon</span>
      </div>
    </Dialog>
  )
}

try{ TriageAgentDialog.displayName ||= 'TriageAgentDialog' } catch {}